import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Payment, UpdatePaxPay } from '../../actions/payment';
import { CheckOut } from '../../actions/analytics';
import { ToggleFooterModal } from '../../actions/utils';
import { submit, getFormValues, isValid } from 'redux-form';
import { serializeObj, customFormErrors } from '../../helpers/formHelper';
import { calculateDueDate, checkLockout, removeProperty } from '../../helpers/utils';
import ReactModal from 'react-modal';
// import ReactGA from 'react-ga';
import SecurePopup from '../shared/securePopup';
import { ISOCurrencyCovert } from '../../helpers/locationHelper';
import { history } from '../app';
import dayjs from 'dayjs';
import _filter from 'lodash/filter';
import { CYOA_NETWORK_IDS } from '../../config';

class PaymentProcessing extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      amount:"deposit", //amountOption
      subtotal:"",
      discount:"",
      deposit:"",
      depositPerson:"",
      accommodation:"",
      //showPaymentModal:false,
      processing:false,
      secureIsOpen:false,
      termsCheck:false,
      fullPayment:false, //only show full payment on tours with close departure dates,
      bookExpiresModalOpen:false
    }
    this.onAmountChange = this.onAmountChange.bind(this);
    this.onBookNow = this.onBookNow.bind(this);
    //this.openPaymentModal = this.openPaymentModal.bind(this); (DEPRECATE)
    //this.closePaymentModal = this.closePaymentModal.bind(this); (DEPRECATE)
    this.onSecureHandler = this.onSecureHandler.bind(this);
    this.handleTermsChange = this.handleTermsChange.bind(this);
    this.termsHandler = this.termsHandler.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.closeExpireModal = this.closeExpireModal.bind(this);
  }

  // (DEPRECATE)
  // openPaymentModal(){
  //   ReactGA.pageview('book.busabout.com/modal/payment-modal');
  //   this.setState({showPaymentModal:true});
  // }
  // closePaymentModal(){ this.setState({ showPaymentModal:false});}

  closeExpireModal(){
    this.setState({bookExpiresModalOpen:false});
    history.push('/');
  }

  documentClickHandler(e){
   try{
      if(e.target.offsetParent.className !== "secure-container" || e.target.offsetParent.className !== "secure-popup payment"){
        this.setState({secureIsOpen:false});
      }
    }catch(e){}
  }

  componentDidMount(){

      const { bookingGroup, itineraries } = this.props;


      document.body.addEventListener('click', this.documentClickHandler);

      // Populate payment details (bookingGroup in state)
      if(bookingGroup.trips !== undefined){
        this.populatePaymentDetails(bookingGroup, itineraries);
        this.initExpireModal(bookingGroup);
      }

      //reset payment processing
      this.setState({processing:false});
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }

  componentDidUpdate(prevProps, prevState) {

    const { bookingGroup, paxDetailsValues, paxBillingValues, itineraries } = this.props;

    // Populate payment details (bookingGroup loaded)
    if(bookingGroup !== prevProps.bookingGroup){
      this.initExpireModal(bookingGroup);
      if(bookingGroup.trips.length !== 0) {
        this.populatePaymentDetails(bookingGroup, itineraries);
      }
    }

    // Populate only on CYO tours
    if(itineraries !== prevProps.itineraries){
      if(bookingGroup.trips.length !== 0) {
        this.populatePaymentDetails(bookingGroup, itineraries);
      }

   
      // CYO tour with accommodation & CYO tour with deposit paid (later release)
      // if(itineraries.accomm_total !== "0.00" || itineraries.total_paid !== "0.00"){ }

       // Set full payments - CYO tours with(out) accommodation
      this.setState({fullPayment:true, amount:'full'});  


    }


    // Remove nationality error message once field selected
    if(paxDetailsValues !== prevProps.paxDetailsValues){
      if(paxDetailsValues.nationality && paxDetailsValues.nationality !== ""){
        customFormErrors({
          dropdown:document.querySelector('.passenger-details-item .nationality .filterDropdown-btn'),
          errorText:document.querySelector('.passenger-details-item .nationality .form-error'),
          formValue:this.props.paxDetailsValues.nationality,
          addRemove:'remove'
        });
      }
      if(paxDetailsValues.state && paxDetailsValues.state !== ""){
        customFormErrors({
          dropdown:document.querySelector('.passenger-details-item .state .filterDropdown-btn'),
          errorText:document.querySelector('.passenger-details-item .state .form-error'),
          formValue:this.props.paxDetailsValues.state,
          addRemove:'remove'
        });
      }

      //
      if(checkLockout(bookingGroup) && paxDetailsValues.phonePrefix && paxDetailsValues.phonePrefix !== ""){
        customFormErrors({
          dropdown:document.querySelector('.passenger-details-item .phone .filterDropdown-btn'),
          errorText:document.querySelector('.passenger-details-item .phone .form-error'),
          formValue:this.props.paxDetailsValues.phonePrefix,
          addRemove:'remove'
        });
      }
    }

    if(paxBillingValues !== prevProps.paxBillingValues){
        if(paxBillingValues.country && paxBillingValues.country !== ""){
          customFormErrors({
            dropdown:document.querySelector('.passenger-billing-form .nationality .filterDropdown-btn'),
            errorText:document.querySelector('.passenger-billing-form .nationality .form-error'),
            formValue:this.props.paxBillingValues.country,
            addRemove:'remove'
          });
        }
    }



  }


  initExpireModal(bookingGroup){

    // Compare current time with booking time and use the
    // difference as the expiry time offset.
    if(process.env.REACT_APP_EXPIRE_MODAL_DISABLE === "true") return;

     const timeDiff = dayjs(new Date(bookingGroup.trips[0].booking_date)).diff(dayjs(new Date()), 'minutes');
     let expiryTime;

    if(process.env.REACT_APP_ENV === "production") {
       expiryTime = timeDiff * 60000;
    }else{
      const debugTime = (process.env.REACT_APP_EXPIRE_MODAL_DEBUG_TIME !== "false") ? process.env.REACT_APP_EXPIRE_MODAL_DEBUG_TIME : timeDiff;
      expiryTime =  debugTime * 60000;
    }

    setTimeout(() => {
      this.setState({bookExpiresModalOpen:true});
    }, expiryTime);

  }

  populatePaymentDetails(bookingGroup, itineraries){

    const HAS_CYO = _filter(bookingGroup.trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id})[0];
  
    let _accommodation = 0;
    let _deposit = 0;
    let _discount = 0;
    let _subtotal = 0;

    if(HAS_CYO !== undefined && Object.keys(HAS_CYO).length > 0){

      if(itineraries !== undefined){

        _accommodation = 0;
        _discount = parseFloat(itineraries.discount);
        _subtotal = parseFloat(itineraries.sub_total);

        const clientBookings = bookingGroup.trips;
        for(let i = 0; i < clientBookings.length; i++){
          for(let ii = 0; ii < clientBookings[i].passengers.length; ii++){
            _deposit += clientBookings[i].passengers[ii].deposit;
          }
        }


        for(let i = 0; i < itineraries.sectors.length; i++){
          if(itineraries.sectors[i].accommodation.bookings !== undefined){
            _accommodation +=  parseFloat(itineraries.sectors[i].accommodation.bookings.total);
          }
        }

        //Subtotal including any accommodation
        _subtotal += _accommodation;

        this.setState({
          fullPayment:(_discount === _subtotal) ? true : false,
          subtotal:_subtotal.toFixed(2),
          deposit:_deposit.toFixed(2),
          discount:_discount.toFixed(2),
          depositPerson:(_deposit / itineraries.content.nr_pax).toFixed(2),
          accommodation:_accommodation.toFixed(2)
        }, () => {
          if(this.state.fullPayment){ 
            this.setState({
              amount:'full',
              subtotal:itineraries.grand_total
            });
          }
        });

      }

    }else{

      const clientBookings = bookingGroup.trips;
      for(let i = 0; i < clientBookings.length; i++){
        for(let ii = 0; ii < clientBookings[i].passengers.length; ii++){
          _subtotal += clientBookings[i].passengers[ii].price;
          _discount += clientBookings[i].passengers[ii].discount;
          _deposit += clientBookings[i].passengers[ii].deposit;
        }
      }



      this.setState({
        fullPayment:(_discount === _subtotal) ? true : false,
        subtotal:_subtotal.toFixed(2),
        deposit:_deposit.toFixed(2),
        discount:_discount.toFixed(2),
        depositPerson:(_deposit / clientBookings[0].passengers.length).toFixed(2),
        accommodation:_accommodation.toFixed(2)
      }, () => {
        if(this.state.fullPayment) this.setState({amount:'full'});
      });


    }
  }
  postPaymentModal(){



    const { bookingGroup, paxDetailsValues, form, UpdatePaxPay, paxBillingValues, itineraries } = this.props;

    //Format DOB from DD/MM/YYYY to YYYY-DD-MM without mutating original paxDetailsValues (TMS format)
    //Copy phoneLockout property into phone property
    const paxDetailsValuesMod = Object.assign({}, paxDetailsValues, {
      dob:paxDetailsValues.dob.split("/").reverse().join("-"),
      phone:(paxDetailsValues.phone === "" && paxDetailsValues.phoneLockout !== "") ? paxDetailsValues.phoneLockout : paxDetailsValues.phone
    });

    //Remove 'phoneLockout' property if exist
    const paxDetailsValuesRemoveProp = removeProperty(paxDetailsValuesMod, 'phoneLockout');

    const isLockout = checkLockout(bookingGroup, itineraries) ? 1 : 0;
    const tmsFields = serializeObj(paxDetailsValuesRemoveProp) + "&amountOption=" + this.state.amount + "&lockout="+isLockout + '&' + serializeObj(bookingGroup.trips[0].iso_currency_code === "GBP" ? paxBillingValues : "");

     
    //CHECKOUT TRACKING
    CheckOut(bookingGroup)

    //UPDATE LEAD PAX DETAILS AND POST PAYMENT (POST CALL IN UPDATE CALLBACK)
    UpdatePaxPay(bookingGroup, form, bookingGroup.trips[0].iso_currency_code, this.paymentPayable(), tmsFields);


    //COMMENT OUT FOR NOW (DEPRECATE)
    // this.setState({
    //   showPaymentLoading:true,
    //   showPaymentModal:true
    // }, ()=>{
    //   document.querySelector(".payment-modal iframe").src = `${paymentURL}?currency=${iso_currency_code}&reference_number=${bookingGroup.group_booking_id}&amount=${this.paymentPayable()}&guid=${bookingGroup.token_guid}&api_token=${process.env.REACT_APP_API_TOKEN}&${tmsFields}`;
    // });



  }


  calculateDifference = (price1, price2) => {
      return (parseFloat(price1) - parseFloat(price2)).toFixed(2);
  }

  onAmountChange(e){
    this.setState({amount:e.target.value});
  }


  onBookNow(e){

    e.preventDefault();

    const { paxDetailsValid, submit, bookingGroup } = this.props;


     //Validate Passenger
     submit('PassengerDetails');


     //Validate GBP Billing address
      if(bookingGroup.trips[0].iso_currency_code === "GBP"){
        submit('PassengerBilling');

        customFormErrors({
          dropdown:document.querySelector('.passenger-billing-form .nationality .filterDropdown-btn'),
          errorText:document.querySelector('.passenger-billing-form .nationality .form-error'),
          formValue:this.props.paxBillingValues.country,
          addRemove:'add'
        })

      }

     //check if custom nationality exist and valid
     customFormErrors({
       dropdown:document.querySelector('.passenger-details-item .nationality .filterDropdown-btn'),
       errorText:document.querySelector('.passenger-details-item .nationality .form-error'),
       formValue:this.props.paxDetailsValues.nationality,
       addRemove:'add'
     })


     customFormErrors({
       dropdown:document.querySelector('.passenger-details-item .state .filterDropdown-btn'),
       errorText:document.querySelector('.passenger-details-item .state .form-error'),
       formValue:this.props.paxDetailsValues.state,
       addRemove:'add'
     })

     if(checkLockout(bookingGroup)){
       customFormErrors({
         dropdown:document.querySelector('.passenger-details-item .phone .filterDropdown-btn'),
         errorText:document.querySelector('.passenger-details-item .phone .form-error'),
         formValue:this.props.paxDetailsValues.phonePrefix,
         addRemove:'add'
       })
     }


    //Scroll to error on page - small screen
    if(window.innerWidth < 640){
      setTimeout(()=>{
        if(document.getElementsByClassName("error")[0]){

          var errorScrollPosition = document.getElementsByClassName("error")[0].getBoundingClientRect().top + window.scrollY;
          var scrollOffset = 73;

          window.scroll(0, errorScrollPosition - scrollOffset);
        }
      },100);
    }


    //Check term and conditions checkbox
    if(!this.state.termsCheck){
      document.querySelector('.terms-checkbox .payment-info-text').classList.add('error');
      document.querySelector('.terms-checkbox .checkmark').classList.add('error');
    }


    //Check all validation
    if(paxDetailsValid && this.validateCustomForms('nationality') && this.validateCustomForms('state') && this.validatePhoneNumber(bookingGroup) && this.state.termsCheck && this.validatePassengerBilling(bookingGroup) && this.validateCustomForms('country', bookingGroup) ){
      this.setState({processing:true});
      this.postPaymentModal();
    }

  }

  validatePassengerBilling(bookingGroup){
    if(bookingGroup.trips[0].iso_currency_code === "GBP"){
      if(process.env.REACT_APP_GBP_BILLING_DISABLED === "true") return true;
      return this.props.paxBillingValid;
    }else{
      return true;
    }
  }

  validatePhoneNumber(bookingGroup){
    //Phone number required for lockout days
    if(checkLockout(bookingGroup)){
      const phoneDropdown = document.querySelector('.passenger-details-item .phone .filterDropdown-btn');
      const { paxDetailsValues, paxDetailsValues:{ phonePrefix } } = this.props;

      if(window.innerWidth > 640){

        if(phoneDropdown !== null) {
          return (paxDetailsValues && phonePrefix === "") ? false : true;
        }

      }else{
        return true
      }
    }else{
      return true;
    }
  }


  validateCustomForms(formType, bookingGroup){

    //Validates nationality / state dropdown menu for non-mobile
    const nationalityDropdown = document.querySelector('.passenger-details-item .nationality .filterDropdown-btn');
    const stateDropdown = document.querySelector('.passenger-details-item .state .filterDropdown-btn');
    const countryDropdown = document.querySelector('.passenger-billing-form .nationality .filterDropdown-btn');

    const { paxDetailsValues, paxDetailsValues:{ nationality, state }, paxBillingValues, paxBillingValues:{country} } = this.props;


    if(window.innerWidth > 640){

        if(formType === 'country' && countryDropdown !== null){
          if(bookingGroup.trips[0].iso_currency_code === "GBP"){
            return (paxBillingValues && country === "") ? false: true;
          }else{
            return true;
          }
        }

        if(formType === 'nationality' && nationalityDropdown !== null) {
          return (paxDetailsValues && nationality === "") ? false : true;
        }

        if(formType === 'state' && nationalityDropdown !== null && stateDropdown !== null){
          return (paxDetailsValues && state === "") ? false : true;
        }else{
          return true;
        }

    }else{
        return true;
    }
  }


  paymentPayable(){

    const { amount, subtotal, deposit} = this.state;

    if(amount === "") return;
    if(amount === "full") return subtotal;
    if(amount === "deposit") return deposit;
  }


  remainingBalance(){

    const { amount, deposit, subtotal, discount } = this.state;

    const fullAmount = this.calculateDifference(subtotal, discount);

    if(amount === "") return;
    if(amount === "full") {
      const diff = this.calculateDifference(fullAmount, fullAmount);
      if(diff !== 'NaN') return diff;
    }
    if(amount === "deposit") {
      const diff = this.calculateDifference(subtotal, deposit);
      if(diff !== 'NaN') return diff;
    }
  }

  onSecureHandler(){
    this.setState({secureIsOpen:!this.state.secureIsOpen});
  }

  handleTermsChange(){
    this.setState({termsCheck: !this.state.termsCheck}, () => {
      if(this.state.termsCheck){
        document.querySelector('.terms-checkbox .payment-info-text').classList.remove('error');
        document.querySelector('.terms-checkbox .checkmark').classList.remove('error');
      }
    });
  }

  termsHandler(e){
    e.preventDefault();
    this.props.ToggleFooterModal(e.target.href, true);
  }

  render() {

    const { amount, grandTotal, depositPerson, secureIsOpen, processing, termsCheck, /*showPaymentModal,*/ fullPayment, bookExpiresModalOpen, accommodation } = this.state;
    const { bookingGroup } = this.props;

    const _currency = (bookingGroup.trips !== undefined && bookingGroup.trips.length > 0 ) ? ISOCurrencyCovert(bookingGroup.trips[0].iso_currency_code) : "";
    const _departureDate = (bookingGroup.trips !== undefined && bookingGroup.trips.length > 0 ) ? bookingGroup.trips[0].departure_date : "";

    const _dueDate = calculateDueDate(_departureDate,'45');



    return (


      <div className="payment-processing">

      <div className="row">

      <div className="column small-12 large-6 no-padding-right-large">

        <div className="payment-box">
        <form className="paymentamoundform" noValidate>
            <div className="row">
              <div className="column small-9 medium-7 large-6">
                <h5 className="busabout-h5 orange-text">Payment option</h5>
                <p>How would we like to pay?</p>
              </div>
              <div className="column small-3 medium-5 large-6 end">
                <div className="card-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1168 -1649 32 20.228">
                      <path fill="#124c8f" fillRule="evenodd" d="M-1167.999-1649h32v20.228h-32z"/>
                      <path d="M-1167.002-1635.031v-13.693h30.73v15.354h-29.069a1.674 1.674 0 0 1-1.661-1.661z" fill="#fff" fillRule="evenodd"/>
                      <path fill="#124c8f" fillRule="evenodd" d="M-1139.273-1637.159l-.276-1.336h-3l-.492 1.336h-2.459l3.518-8.329a1.084 1.084 0 0 1 1.09-.67h1.9l1.888 9zm-2.6-3.183h1.943l-.7-3.368zm-3.442-3.652l.339-1.932a6.852 6.852 0 0 0-2.123-.393c-1.171 0-3.951.508-3.951 2.979 0 2.325 3.263 2.354 3.263 3.575s-2.927 1-3.893.233l-.35 2.02a6.642 6.642 0 0 0 2.663.509c1.609 0 4.038-.828 4.038-3.081 0-2.34-3.292-2.558-3.292-3.575s2.3-.887 3.307-.334m-8.17 6.834h-2.359l1.474-9h2.36l-1.475 9m-12.531-8.847a9.18 9.18 0 0 1 3.5 1.745 7.012 7.012 0 0 1 2.173 2.96l-.794-4.047a1.007 1.007 0 0 0-1.119-.81 1.007 1.007 0 0 1 1.119.81l.794 4.047.266 1.333 2.249-6.19h2.539l-3.753 9h-2.458l-2.049-7.82a8.879 8.879 0 0 0-2.467-1.028z"/>
                      <path d="M-1160.342-1641.301l-.794-4.047a1.007 1.007 0 0 0-1.119-.81h-3.717l-.044.152a9.168 9.168 0 0 1 3.5 1.746 7.012 7.012 0 0 1 2.174 2.959" fill="#f9a533" fillRule="evenodd"/>
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1132 -1649 32 20.228">
                      <path d="M-1132-1649h32v20.228h-32z" fillRule="evenodd" fill="#fff"/>
                      <path fillRule="evenodd" fill="#0066b2" d="M-1132-1649h32v3.32h-32z"/>
                      <path fillRule="evenodd" fill="#f9a533" d="M-1132-1632.399h32v3.32h-32z"/>
                      <path d="M-1106.896-1635.114h.418v.131a.6.6 0 0 1 .392-.175c.257 0 .4.141.4.471v.777h-.418v-.714c0-.1-.026-.175-.151-.175a.392.392 0 0 0-.219.11v.779h-.426l.01-1.2m-.911-.042a.646.646 0 1 1-.678.645.617.617 0 0 1 .678-.645zm0 .975c.2 0 .26-.172.26-.33s-.06-.33-.26-.33-.26.172-.26.33.06.33.26.33zm-1.625-.936h.418v.169a.346.346 0 0 1 .308-.2.65.65 0 0 1 .137.014l-.055.411a.491.491 0 0 0-.149-.024.3.3 0 0 0-.248.141l-.007.7h-.418l.01-1.2m-1.136-.011h.189v-.409h.4l-.01.409h.344l-.007.3h-.344c0 .167-.012.344-.012.447s.027.156.12.156a.3.3 0 0 0 .154-.057l.091.282a.822.822 0 0 1-.413.119c-.339 0-.356-.212-.356-.49 0-.148.012-.3.012-.456h-.18l.01-.3m-.153 1.121a.956.956 0 0 1-.445.124.6.6 0 0 1-.661-.616.642.642 0 0 1 .688-.674.862.862 0 0 1 .411.105l-.135.272a.519.519 0 0 0-.2-.048.315.315 0 0 0-.348.323.306.306 0 0 0 .313.308.528.528 0 0 0 .226-.069l.149.275m-1.335-.055a.887.887 0 0 1-.551.179.6.6 0 0 1-.639-.619.655.655 0 0 1 .651-.671c.462 0 .606.325.606.738h-.839a.256.256 0 0 0 .291.251.539.539 0 0 0 .341-.119l.139.241zm-.308-.616c0-.124-.06-.237-.2-.237a.288.288 0 0 0-.26.237zm-1.549-1.04h.418v1.792h-.418v-1.792m-1.437.139h1.149v.344h-.714v.318h.712v.33h-.714v.318h.7v.344h-1.133v-1.654" fill="#045ea0" fillRule="evenodd"/>
                      <path d="M-1105.368-1637.095a.375.375 0 1 1 .378.37.373.373 0 0 1-.378-.37zm.378.28a.282.282 0 1 0-.288-.28.284.284 0 0 0 .288.28zm-.054-.119h-.077v-.327h.139a.152.152 0 0 1 .084.017.1.1 0 0 1 .042.081.089.089 0 0 1-.057.085l.06.144h-.085l-.052-.129h-.054v.129zm0-.185h.042a.1.1 0 0 0 .047-.006.045.045 0 0 0 .019-.038.041.041 0 0 0-.018-.032.106.106 0 0 0-.049-.007h-.041v.083z" fill="#0161ab" fillRule="evenodd"/>
                      <path fillRule="evenodd" fill="#0066b2" d="M-1107.218-1636.702l-.212-1.019h-2.3l-.38 1.019h-1.891l2.7-6.35a.832.832 0 0 1 .837-.511h1.463l1.45 6.862zm-1.993-2.427h1.487l-.536-2.569zm-2.646-2.785l.259-1.474a5.293 5.293 0 0 0-1.629-.3c-.9 0-3.034.388-3.034 2.272 0 1.773 2.506 1.8 2.506 2.726s-2.247.765-2.989.178l-.269 1.54a5.13 5.13 0 0 0 2.045.388c1.236 0 3.1-.632 3.1-2.349 0-1.784-2.528-1.951-2.528-2.726s1.764-.676 2.539-.255m-6.273 5.212h-1.811l1.132-6.862h1.812l-1.133 6.862m-9.622-6.75a7.071 7.071 0 0 1 2.688 1.335 5.345 5.345 0 0 1 1.668 2.257l-.61-3.086a.771.771 0 0 0-.859-.618.771.771 0 0 1 .859.618l.61 3.086.2 1.016 1.731-4.72h1.95l-2.882 6.862h-1.887l-1.574-5.962a6.846 6.846 0 0 0-1.894-.788z"/>
                      <path fillRule="evenodd" fill="#f9a533" d="M-1123.396-1639.86l-.61-3.086a.771.771 0 0 0-.859-.618h-2.856l-.032.112a7.062 7.062 0 0 1 2.689 1.335 5.345 5.345 0 0 1 1.668 2.257"/>
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1096 -1649 32 20.228">
                      <path d="M-1096-1649h32v20.228h-32z" fillRule="evenodd" fill="none"/>
                      <path d="M-1077.098-1638.864a8.759 8.759 0 1 1-8.758-8.753 8.755 8.755 0 0 1 8.759 8.753" fill="#d82332" fillRule="evenodd"/>
                      <path fillRule="evenodd" fill="#f1ab3e" d="M-1074.011-1647.617a8.732 8.732 0 0 0-5.88 2.266 8.908 8.908 0 0 0-.884.927h1.769a8.96 8.96 0 0 1 .668.927h-3.105a8.791 8.791 0 0 0-.5.927h4.114a8.712 8.712 0 0 1 .371.927h-4.861a8.719 8.719 0 0 0-.255.926h5.365a8.812 8.812 0 0 1-.254 4.634h-4.856a8.8 8.8 0 0 0 .371.927h4.115a8.791 8.791 0 0 1-.505.927h-3.1a8.847 8.847 0 0 0 .668.926h1.769a8.736 8.736 0 0 1-.885.927 8.756 8.756 0 1 0 5.875-15.241"/>
                      <path fillRule="evenodd" fill="#f1ab3e" d="M-1066.517-1634.056a.283.283 0 1 1 .283.283.283.283 0 0 1-.283-.283zm.283.215a.215.215 0 1 0-.215-.215.215.215 0 0 0 .215.215zm-.038-.091h-.058v-.248h.105a.117.117 0 0 1 .064.012.077.077 0 0 1 .031.062.068.068 0 0 1-.043.064l.046.109h-.064l-.038-.1h-.047v.1zm0-.141h.032a.075.075 0 0 0 .035 0 .034.034 0 0 0 .015-.029.033.033 0 0 0-.014-.025.079.079 0 0 0-.037 0h-.035v.063z"/>
                      <path fillRule="evenodd" fill="#fffffe" d="M-1066.517-1636.822a.283.283 0 1 1 .283.283.283.283 0 0 1-.283-.283zm.283.215a.215.215 0 1 0-.215-.215.215.215 0 0 0 .215.215zm-.038-.091h-.058v-.248h.105a.116.116 0 0 1 .063.013.073.073 0 0 1 .032.062.068.068 0 0 1-.043.064l.046.109h-.064l-.038-.1h-.047v.1zm0-.141h.032a.071.071 0 0 0 .035 0 .034.034 0 0 0 .014-.029.033.033 0 0 0-.014-.026.084.084 0 0 0-.037 0h-.034v.063z"/>
                      <path d="M-1067.412-1640.839l-.211 1.283a1.188 1.188 0 0 0-.908-.589 1.473 1.473 0 0 0-1.2.9 7.819 7.819 0 0 1-.81-.223 5.388 5.388 0 0 0 .042-.543h-.874c-.119 1.118-.33 2.25-.5 3.368l-.044.243h.952c.128-.833.226-1.526.3-2.075.325-.294.488-.549.816-.533a3.1 3.1 0 0 0-.23 1.172c0 .9.457 1.5 1.148 1.5a1.121 1.121 0 0 0 .877-.4l-.045.336h.9l.724-4.439zm-1.189 3.606c-.324 0-.487-.24-.487-.712 0-.71.306-1.213.738-1.213.327 0 .5.248.5.707 0 .716-.311 1.218-.754 1.218zm-4.277-.693a1.572 1.572 0 0 0-.212-.015c-.539 0-.812.185-.812.549a.332.332 0 0 0 .341.368c.387 0 .667-.368.683-.9zm.692 1.608h-.788l.018-.374a1.2 1.2 0 0 1-1 .437.888.888 0 0 1-.869-.987c0-.879.614-1.392 1.669-1.392a3.168 3.168 0 0 1 .387.028.893.893 0 0 0 .037-.235c0-.239-.165-.328-.61-.328a3.164 3.164 0 0 0-1.007.162l.132-.812a3.793 3.793 0 0 1 1.138-.191c.817 0 1.249.367 1.248 1.059a4.582 4.582 0 0 1-.077.715c-.082.522-.26 1.645-.284 1.917zm-3.202-3.56a1.811 1.811 0 0 1 .85.24l.156-.963a2.8 2.8 0 0 0-1.045-.376 1.9 1.9 0 0 0-1.553.836c-.552-.183-.779.186-1.057.554l-.244.058a1.844 1.844 0 0 0 .03-.363h-.874c-.119 1.118-.33 2.25-.5 3.368l-.043.243h.951c.159-1.031.245-1.691.3-2.138l.358-.2c.054-.2.221-.266.557-.258a4.054 4.054 0 0 0-.068.74c0 1.181.639 1.917 1.662 1.917a2.97 2.97 0 0 0 .841-.13l.167-1.012a1.851 1.851 0 0 1-.808.228c-.553 0-.887-.408-.887-1.082 0-.978.5-1.663 1.207-1.663m-4.605 3.478a3.243 3.243 0 0 1-.97.146 1.436 1.436 0 0 1-1.61-1.611c0-1.235.7-2.143 1.654-2.143a1.207 1.207 0 0 1 1.278 1.307 3.91 3.91 0 0 1-.116.888h-1.884c-.064.524.272.742.821.742a2.242 2.242 0 0 0 .983-.228l-.157.9zm-.531-2.141c.005-.076.1-.644-.44-.644-.3 0-.516.23-.6.644zm-2.414 2.22a2.173 2.173 0 0 1-.683.117.7.7 0 0 1-.752-.793 8.378 8.378 0 0 1 .131-.963c.055-.338.412-2.464.412-2.464h.945l-.11.546h.485l-.129.868h-.487c-.11.687-.266 1.542-.268 1.655 0 .187.1.268.326.268a.765.765 0 0 0 .256-.034l-.126.8m-3.709-2.465a1.054 1.054 0 0 0 .724 1.008c.385.181.444.234.444.4 0 .225-.17.327-.546.327a2.681 2.681 0 0 1-.852-.142l-.131.833a4.408 4.408 0 0 0 .989.107c1 0 1.467-.382 1.467-1.207a.988.988 0 0 0-.67-1.006c-.4-.183-.444-.224-.444-.393 0-.2.158-.3.465-.3a5.292 5.292 0 0 1 .683.055l.135-.837a6.479 6.479 0 0 0-.837-.071c-1.058.004-1.427.555-1.427 1.226m-1.185.861a1.582 1.582 0 0 0-.212-.015c-.539 0-.812.185-.812.549a.332.332 0 0 0 .341.368c.387 0 .667-.368.683-.9zm.7 1.608h-.788l.018-.374a1.2 1.2 0 0 1-1 .437.889.889 0 0 1-.869-.987c0-.879.614-1.392 1.669-1.392a3.177 3.177 0 0 1 .388.028.891.891 0 0 0 .037-.235c0-.239-.166-.328-.61-.328a3.16 3.16 0 0 0-1.007.162l.132-.812a3.793 3.793 0 0 1 1.138-.191c.817 0 1.249.367 1.248 1.059a4.616 4.616 0 0 1-.077.715c-.083.522-.26 1.645-.284 1.917zm-3.117.056h-.951l.545-3.413-1.216 3.413h-.649l-.08-3.393-.572 3.393h-.89l.743-4.439h1.368l.038 2.748.923-2.748h1.476l-.735 4.439" fill="#0c2d5a" fillRule="evenodd"/>
                      <path fillRule="evenodd" fill="#fffffe" d="M-1066.821-1636.538h-.9l.045-.336a1.121 1.121 0 0 1-.877.4c-.691 0-1.148-.6-1.148-1.5 0-1.2.709-2.213 1.547-2.213a1.073 1.073 0 0 1 .908.492l.211-1.283h.938l-.724 4.439zm-1.4-.834c.443 0 .754-.5.754-1.217 0-.459-.177-.708-.5-.708-.431 0-.738.5-.738 1.213 0 .473.164.711.488.711zm-2.877-2.875c-.119 1.118-.33 2.249-.5 3.367l-.043.243h.951c.34-2.208.422-2.639.956-2.585a3.538 3.538 0 0 1 .361-1.047c-.4-.083-.621.142-.912.569a3.287 3.287 0 0 0 .057-.548h-.874m-1.5 2.045a1.572 1.572 0 0 0-.212-.015c-.539 0-.812.185-.812.549a.332.332 0 0 0 .341.368c.387 0 .667-.368.683-.9zm.692 1.608h-.788l.018-.374a1.2 1.2 0 0 1-1 .437.888.888 0 0 1-.869-.987c0-.879.614-1.392 1.669-1.392a3.168 3.168 0 0 1 .387.028.893.893 0 0 0 .037-.235c0-.239-.165-.328-.61-.328a3.164 3.164 0 0 0-1.007.162l.132-.812a3.793 3.793 0 0 1 1.138-.191c.817 0 1.249.367 1.248 1.059a4.582 4.582 0 0 1-.077.715c-.082.522-.26 1.645-.284 1.917zm-2.216-4.291l-.156.963a1.817 1.817 0 0 0-.85-.24c-.71 0-1.208.686-1.208 1.664 0 .674.335 1.081.888 1.081a1.842 1.842 0 0 0 .808-.228l-.167 1.01a2.965 2.965 0 0 1-.84.13c-1.024 0-1.662-.736-1.662-1.917 0-1.587.882-2.7 2.142-2.7a3.3 3.3 0 0 1 1.045.231m-4.724.645c-.12 1.118-.331 2.249-.5 3.367l-.043.243h.951c.34-2.208.422-2.639.955-2.585a3.564 3.564 0 0 1 .361-1.047c-.4-.083-.621.142-.912.569a3.256 3.256 0 0 0 .057-.548h-.873m-.863 3.57a3.243 3.243 0 0 1-.97.146 1.436 1.436 0 0 1-1.61-1.611c0-1.235.7-2.143 1.654-2.143a1.207 1.207 0 0 1 1.277 1.307 3.91 3.91 0 0 1-.116.888h-1.882c-.064.524.272.742.821.742a2.242 2.242 0 0 0 .983-.228l-.157.9zm-.531-2.141c.005-.076.1-.644-.44-.644-.3 0-.516.23-.6.644zm-2.413 2.22a2.173 2.173 0 0 1-.683.117.7.7 0 0 1-.752-.793 8.378 8.378 0 0 1 .131-.963c.055-.338.412-2.464.412-2.464h.945l-.11.546h.485l-.129.868h-.487c-.11.687-.266 1.542-.268 1.655 0 .187.1.268.326.268a.765.765 0 0 0 .256-.034l-.126.8m-3.705-2.464a1.054 1.054 0 0 0 .724 1.008c.385.181.444.234.444.4 0 .225-.17.327-.546.327a2.681 2.681 0 0 1-.852-.142l-.131.833a4.408 4.408 0 0 0 .989.107c1 0 1.467-.382 1.467-1.207a.988.988 0 0 0-.67-1.006c-.4-.183-.444-.224-.444-.393 0-.2.158-.3.465-.3a5.292 5.292 0 0 1 .683.055l.135-.837a6.478 6.478 0 0 0-.837-.071c-1.064 0-1.432.555-1.429 1.222m-1.183.864a1.582 1.582 0 0 0-.212-.015c-.539 0-.812.185-.812.549a.332.332 0 0 0 .341.368c.387 0 .667-.368.683-.9zm.692 1.608h-.788l.018-.374a1.2 1.2 0 0 1-1 .437.889.889 0 0 1-.869-.987c0-.879.614-1.392 1.669-1.392a3.176 3.176 0 0 1 .388.028.891.891 0 0 0 .037-.235c0-.239-.166-.328-.61-.328a3.16 3.16 0 0 0-1.007.162l.132-.812a3.793 3.793 0 0 1 1.138-.191c.817 0 1.249.367 1.248 1.059a4.616 4.616 0 0 1-.077.715c-.083.522-.26 1.645-.284 1.917zm-3.117.057h-.948l.548-3.413-1.219 3.413h-.648l-.08-3.393-.573 3.393h-.89l.743-4.439h1.367l.038 2.748.923-2.748h1.478l-.739 4.439"/>
                    </svg>

                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1060 -1649 32 20.228">
                    <path d="M-1060-1649h32v20.226h-32z" fillRule="evenodd" fill="none"/>
                    <path fillRule="evenodd" fill="#d82332" d="M-1029.334-1638.864a8.758 8.758 0 1 1-8.759-8.753 8.755 8.755 0 0 1 8.759 8.753"/>
                    <path d="M-1044.862-1633.305a8.688 8.688 0 0 1-.667-.927h3.1a8.688 8.688 0 0 0 .5-.927h-4.104a8.713 8.713 0 0 1-.371-.927h4.854a8.811 8.811 0 0 0 .254-4.631h-5.361a8.706 8.706 0 0 1 .254-.927h4.852a8.8 8.8 0 0 0-.37-.926h-4.111a8.858 8.858 0 0 1 .5-.927h3.1a8.846 8.846 0 0 0-.667-.926h-1.762a8.836 8.836 0 0 1 .884-.926 8.753 8.753 0 1 0 .885 12.045h-1.77" fill="#0092c7" fillRule="evenodd"/>
                    <path fillRule="evenodd" fill="#d82332" d="M-1030.516-1634.059a.283.283 0 1 1 .283.283.283.283 0 0 1-.283-.283zm.283.215a.215.215 0 1 0-.215-.215.215.215 0 0 0 .215.215zm-.038-.091h-.058v-.249h.1a.113.113 0 0 1 .064.013.075.075 0 0 1 .031.062.068.068 0 0 1-.043.064l.046.11h-.064l-.038-.1h-.042v.1zm0-.141h.032a.078.078 0 0 0 .035 0 .035.035 0 0 0 .015-.029.032.032 0 0 0-.014-.025.079.079 0 0 0-.037 0h-.031v.063z"/>
                    <path d="M-1033.519-1638.558c0 .818-.336 1.3-.866 1.3-.387.006-.621-.318-.621-.8 0-.575.342-1.225.892-1.225.444 0 .6.351.6.725zm1.17.023a1.56 1.56 0 0 0-1.717-1.613 2 2 0 0 0-2.125 2.126 1.533 1.533 0 0 0 1.715 1.648 1.945 1.945 0 0 0 2.127-2.161zm-5.716-1.573c-.138 1.123-.382 2.262-.572 3.387l-.046.245h1.095c.395-2.173.527-2.792 1.354-2.574l.4-1.028c-.577-.211-.948.091-1.284.52a2.54 2.54 0 0 0 .074-.549h-1.018m-.912 3.571a2.837 2.837 0 0 1-.783.117c-.558 0-.863-.285-.863-.792a7.583 7.583 0 0 1 .15-.963c.031-.18.514-2.8.514-2.8h1.084l-.164.868h.556l-.151.886h-.558s-.306 1.538-.306 1.655c0 .186.113.267.372.267a1.044 1.044 0 0 0 .294-.034l-.144.8m-4.412-2.385c0 .458.258.775.845 1.011.449.184.52.237.52.4 0 .228-.2.332-.639.329a3.64 3.64 0 0 1-.989-.141l-.158.836a6.3 6.3 0 0 0 1.154.107c1.172 0 1.714-.384 1.714-1.213a1 1 0 0 0-.783-1.01c-.465-.186-.52-.226-.52-.394 0-.2.184-.3.544-.3a7.193 7.193 0 0 1 .8.054l.159-.841a8.591 8.591 0 0 0-.979-.072c-1.242 0-1.672.559-1.668 1.23m-.628 2.404a4.259 4.259 0 0 1-1.119.147c-1.221 0-1.857-.557-1.857-1.619a1.983 1.983 0 0 1 1.908-2.155 1.307 1.307 0 0 1 1.472 1.314 3.412 3.412 0 0 1-.134.892h-2.17c-.077.519.3.747.947.747a2.9 2.9 0 0 0 1.128-.226l-.171.9zm-.584-2.153c0-.078.121-.635-.508-.648-.347 0-.6.231-.7.648zm-3.089 2.236h-.911l.022-.381a1.462 1.462 0 0 1-1.15.441.949.949 0 0 1-1-.99c0-.887.707-1.4 1.924-1.4a4.213 4.213 0 0 1 .447.028.784.784 0 0 0 .043-.235c0-.243-.191-.332-.7-.332a4.2 4.2 0 0 0-1.161.161l.156-.814a4.978 4.978 0 0 1 1.303-.192c.942 0 1.439.369 1.439 1.063a4.091 4.091 0 0 1-.089.719c-.037.236-.3 1.608-.325 1.932zm-.8-1.619a2.166 2.166 0 0 0-.245-.015c-.621 0-.936.185-.936.55a.357.357 0 0 0 .393.372.838.838 0 0 0 .787-.907zm-2.751 1.652h-1.09l.648-3.411-1.492 3.411h-.994l-.182-3.392-.65 3.392h-.989l.842-4.438h1.7l.142 2.474 1.087-2.475h1.841l-.859 4.438" fill="#0c2d5a" fillRule="evenodd"/>
                    <path d="M-1032.316-1636.96a.283.283 0 1 1 .283.283.283.283 0 0 1-.283-.283zm.283.215a.215.215 0 1 0-.215-.215.215.215 0 0 0 .215.215zm-.038-.091h-.058v-.248h.105a.114.114 0 0 1 .064.012.075.075 0 0 1 .031.062.068.068 0 0 1-.043.064l.046.109h-.064l-.038-.1h-.042v.1zm0-.141h.032a.075.075 0 0 0 .035 0 .034.034 0 0 0 .015-.029.031.031 0 0 0-.014-.025.073.073 0 0 0-.037 0h-.031v.063zm-1.171-1.857c0 .818-.336 1.3-.866 1.3-.387.006-.621-.318-.621-.8 0-.575.342-1.225.892-1.225.444 0 .6.351.6.725zm1.17.023a1.56 1.56 0 0 0-1.717-1.613 2 2 0 0 0-2.125 2.126 1.533 1.533 0 0 0 1.715 1.648 1.945 1.945 0 0 0 2.127-2.161zm-5.716-1.575c-.138 1.123-.382 2.262-.572 3.387l-.046.245h1.093c.395-2.173.527-2.792 1.354-2.574l.4-1.028c-.577-.211-.948.091-1.284.52a2.539 2.539 0 0 0 .074-.549h-1.018m-.906 3.572a2.832 2.832 0 0 1-.784.117c-.558 0-.862-.285-.862-.792a7.556 7.556 0 0 1 .149-.963c.031-.18.514-2.8.514-2.8h1.083l-.164.868h.556l-.151.886h-.558s-.307 1.538-.307 1.655c0 .187.113.268.373.268a1.04 1.04 0 0 0 .294-.033l-.145.8m-4.412-2.387c0 .459.258.775.845 1.012.449.184.52.237.52.4 0 .228-.2.332-.638.33a3.643 3.643 0 0 1-.989-.141l-.158.836a6.277 6.277 0 0 0 1.154.107c1.172 0 1.714-.384 1.714-1.213a1 1 0 0 0-.783-1.01c-.465-.186-.52-.226-.52-.394 0-.2.185-.3.544-.3a7.2 7.2 0 0 1 .8.054l.159-.841a8.5 8.5 0 0 0-.979-.072c-1.242 0-1.672.558-1.668 1.23m-.63 2.399a4.251 4.251 0 0 1-1.119.147c-1.221 0-1.857-.557-1.857-1.619a1.983 1.983 0 0 1 1.908-2.154 1.307 1.307 0 0 1 1.473 1.314 3.422 3.422 0 0 1-.134.892h-2.171c-.077.518.3.747.947.747a2.893 2.893 0 0 0 1.12-.226l-.171.9zm-.584-2.153c0-.078.121-.635-.507-.648-.347 0-.6.231-.7.648zm-3.089 2.24h-.911l.022-.381a1.463 1.463 0 0 1-1.15.44.95.95 0 0 1-1-.99c0-.887.708-1.4 1.924-1.4a4.32 4.32 0 0 1 .448.027.78.78 0 0 0 .043-.234c0-.243-.191-.333-.7-.333a4.22 4.22 0 0 0-1.161.162l.155-.814a4.978 4.978 0 0 1 1.309-.192c.942 0 1.439.369 1.439 1.063a4.109 4.109 0 0 1-.089.719c-.037.236-.3 1.608-.325 1.932zm-.8-1.619a2.042 2.042 0 0 0-.245-.015c-.621 0-.936.184-.936.549a.358.358 0 0 0 .393.373.838.838 0 0 0 .787-.907zm-2.751 1.651h-1.086l.648-3.412-1.492 3.412h-.994l-.182-3.392-.65 3.392h-.989l.842-4.438h1.7l.09 2.747 1.2-2.747h1.773l-.859 4.438" fill="#fffffe" fillRule="evenodd"/>
                  </svg>

                </div>
              </div>
          </div>

        <div className="row">

            <div className="column small-12">
              <div className="payment-amount-box" style={{display:fullPayment ? 'none' : 'block'}}>
              <div className="column small-6">

                <div className="radio">
                  <input id="depositPayment" name="paymentAmount" type="radio" value="deposit" checked={amount === 'deposit'} onChange={this.onAmountChange} />
                  <label htmlFor="depositPayment" className="radio-label">Deposit ({_currency}{grandTotal})</label>
                </div>

              </div>
              <div className="column small-6">

                <div className="radio">
                  <input id="fullPayment" name="paymentAmount" type="radio" value="full" checked={amount === 'full'} onChange={this.onAmountChange}/>
                  <label htmlFor="fullPayment" className="radio-label">Full Payment</label>
                </div>

              </div>
              </div>
            </div>

              <div className="column small-12">
                <p className="term-text" style={{display:(amount === "deposit")? "block" : "none"}}>
                  Deposit calculation is based on a per person rate of {_currency}{depositPerson} and is non-refundable. <br/>
                  All data is passed through a 128bit secure connection.
                </p>
                <p className="term-text" style={{display:fullPayment ? 'block' : 'none'}}>
                For departures in 45 days or less, the option of a deposit payment is not available. This product has to be paid in full to secure the booking.
                </p>
                <div className="secure-logo" onClick={this.onSecureHandler}>
                  <img src="https://images.contentful.com/3ng3kfj0qs70/37bMJCsP4s4eOsiWMimqWi/557725e5f24abae4e9e8f8b2873dc184/icon-secure.svg" alt=""/>
                  Secure payment
                </div>

              </div>

              <div className="column small-12 no-margin" style={{display:secureIsOpen ? "block" : "none"}}>
                <div className="secure-container">
                  <SecurePopup secureLocation="payment"/>
                </div>
              </div>


            </div>
        </form>
      </div>
      </div>

      <div className="column small-12 large-6 no-padding-left-large">
      <div className="total-box">

        <div className="row">
          <div className="column small-12">
            <h4 className="busabout-h4 no-margin">Total payable now</h4>
            <p className="total-text no-margin">{_currency}{this.paymentPayable()}</p>

            <p className="remaining-text" style={{display: this.remainingBalance() === "0.00" ? "none" : "block" }} >Remaining Balance: {_currency}{ this.remainingBalance() }

            <span style={{display: (accommodation === "" || accommodation === "0.00") ? "none" : "inline"}}>
               &nbsp; (due within 14 days)
            </span>

            <span style={{display: (accommodation === "" || accommodation === "0.00") ? "inline" : "none"}}>
               &nbsp; (due before { _dueDate })
            </span>

            </p>



            <p className="remaining-text orange-text" style={{display: (accommodation === "" || accommodation === "0.00") ? "none" : "block"}}>
                <span className="display-block">Accommodation subject to availability to be confirmed via email <sup>*</sup></span>
            </p>

            <p className="remaining-text orange-text" style={{display: checkLockout(bookingGroup) ? "block" : "none" }}>
              This is a <b>"Last Minute"</b> booking. The amount will be pre-authorised on your card but funds will be taken only once the booking is confirmed by our Reservation Team. Learn more about <a href="https://www.busabout.com/terms-conditions/last-minute-bookings" style={{textDecoration:"underline"}} target="_blank" rel="noopener noreferrer" className="busabout--cta--link orange">Last Minute Bookings</a>.</p>
          </div>

          <div className="column small-12 text-center">
            <label className="checkbox-container terms-checkbox">
              <span className="payment-info-text">I accept Busabout <a href="https://www.busabout.com/terms-conditions?SQ_DESIGN_NAME=simple" target="_blank" rel="noopener noreferrer" className="busabout--cta--link orange" onClick={e => this.termsHandler(e)}>Terms & Conditions</a> and our  <a href="https://www.busabout.com/privacy-policy?SQ_DESIGN_NAME=simple" target="_blank" rel="noopener noreferrer" className="busabout--cta--link orange" onClick={e => this.termsHandler(e)}>Privacy Policy</a></span>
              <input name="termcheck" type="checkbox" defaultChecked={termsCheck} onChange={this.handleTermsChange} />
              <span className="checkmark"></span>
            </label>
          </div>

          <div small={12} className="column small-12 text-center">
              <button type="submit" className="busabout--cta orange" onClick={this.onBookNow} disabled={processing}>
                <span style={{display:processing ? "none" : "block"}}>Make a payment now</span>
                <span style={{display:processing ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
              </button>
          </div>

        </div>

      </div>
      </div>
      </div>


      {/*
        (DEPRECATE)
        <ReactModal
          className="payment-modal"
          overlayClassName="modal-overlay white"
          isOpen={showPaymentModal}
          onRequestClose={this.closePaymentModal}
          contentLabel="Payment modal">

            <div className="payment-container">
              <iframe title="Payment modal" src="" frameBorder="0"></iframe>
            </div>

          <button className="modal-close hide-for-small-only" onClick={this.closePaymentModal}>
            <span className="fa fa-times fa-2x"></span>
          </button>

        </ReactModal> */}


       <ReactModal
            className="error-modal"
            overlayClassName="modal-overlay semi-white"
            isOpen={bookExpiresModalOpen}
            onRequestClose={this.closeExpireModal}
            contentLabel="Expire modal">


            <div className="error-modal-container big">
              <div className="row">
                <div className="column small-12">
                  <p className="ba-icon ba_icon_extra_info_alt"></p>
                  <p>The hold period for your booking has expired. Please try again.</p>
                </div>
              </div>
              <div className="row">
                <div className="column small-12 text-center">
                    <button type="button" className="busabout--cta orange back-search" onClick={this.closeExpireModal}>Back to search</button>
                </div>
              </div>
              <button className="modal-close orange" onClick={this.closeExpireModal}>
                <span className="fa fa-times fa-lg"></span>
              </button>
            </div>
          </ReactModal>

    </div>


    );
  }
}


function mapStateToProps(state){

  return {
    form:state.form,
    paxDetailsValues: getFormValues('PassengerDetails')(state),
    paxDetailsValid: isValid('PassengerDetails')(state),
    paxBillingValid: isValid('PassengerBilling')(state),
    paxBillingValues: getFormValues('PassengerBilling')(state),
    bookingGroup:state.bookingGroup.data,
    currency:state.currency,
    currentBooking:state.currentBooking,
    itineraries:state.itineraries.data
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    submit,
    Payment,
    ToggleFooterModal,
    UpdatePaxPay
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentProcessing);



// WEBPACK FOOTER //
// ./src/components/payment/paymentprocessing.js